import AsoHeader from '../../../components/Aso/Header';
import AsoValidarInfo from '../../../components/Aso/Register/AsoValidarInfo';
import AsoValidarInfoTrabalhadorExistente from "../../../components/Aso/Register/AsoValidarInfoTrabalhadorExistente";

export function AsoRegistroValidarInfo() {

  return (
    <div>
      <AsoHeader />
      <AsoValidarInfo />
    </div>
  );
}
